import { IBirthday, IBirthdayParams, IShortItem, ITableRes } from 'types'

import { baseApi } from './baseApi'
import { MAX_PER_PAGE } from 'utils/constants'

export const usersAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_usersSelect: builder.query<ITableRes<IShortItem>, any>({
      query: (params) => ({
        url: '/users/select/',
        params: {...params, page_size: MAX_PER_PAGE},
      }),
      transformResponse: (response: ITableRes<IShortItem>): any => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['users-select'],
    }),
    GET_usersBirthdays: builder.query<ITableRes<IBirthday>, IBirthdayParams>({
      query: (params) => ({
        url: '/birthdays/',
        params
      }),
      providesTags: ['birthdays'],
    }),
    PUT_profilePicture: builder.mutation<void, { id: number, formData: any }>({
      query: ({id, formData}) => ({
        url: `/user-profile-picture/${id}/`,
        method: 'PUT',
        body: formData,
      }),
      invalidatesTags: ['student','parent','staff','teacher'],
    }),
    DELETE_profilePicture: builder.mutation<void, number>({
      query: (id) => ({
        url: `/user-profile-picture/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['student','parent','staff','teacher'],
    }),
  }),
})

export const { 
  useGET_usersSelectQuery, 
  useGET_usersBirthdaysQuery,
  usePUT_profilePictureMutation,
  useDELETE_profilePictureMutation,
} = usersAPI
